module.exports = __webpack_public_path__ + "static/media/googlePlayIcon.b249a1f0.png";